export const DEFAULT_SIDEBAR_WIDTH = 32 * 16; // 32rem

// Returns default width of sidebar
// TODO:
// Potentially might need to get this value from localStorage to share width used in other places of the app.
// But it's up to design decision, so now just return constant
const getDefaultSidebarWidth = () => DEFAULT_SIDEBAR_WIDTH;

export default getDefaultSidebarWidth;
